import React from 'react';
import { NavLink } from 'react-router-dom';
import NavItemFrame from '../primitives/NavItemFrame';
import NavRow from '../primitives/NavRow';
import { Tooltip } from '@frekuent/orbit/components';

type SidebarLinkItemProps = {
	text: string;
	to: string;
	variant?: 'default' | 'highlighted';
	tone?: 'default' | 'premium';
	size?: 'default' | 'collapsed';
	icon?: React.ReactNode;
	disabled?: boolean;
	groupId?: string;
	useIndicator?: boolean;
};

const SidebarLinkItem = ({
	text,
	to,
	variant = 'default',
	tone = 'default',
	size = 'default',
	icon,
	disabled = false,
	groupId = 'default',
	useIndicator = true,
}: SidebarLinkItemProps) => {
	const content = (selected: boolean) => (
		<NavItemFrame
			selected={selected}
			tone={tone}
			size={size}
			variant={variant}
			groupId={groupId}
			useIndicator={useIndicator}
		>
			<NavRow
				text={text}
				leftSlot={icon}
				size={size}
				disabled={disabled}
			/>
		</NavItemFrame>
	);

	if (disabled) {
		return (
			<div
				aria-disabled='true'
				tabIndex={-1}
			>
				{content(false)}
			</div>
		);
	}

	return (
		<li>
			<NavLink
				to={to}
				className='block group'
				end={false}
			>
				{({ isActive }) => {
					if (size === 'collapsed') {
						return (
							<Tooltip
								content={text}
								placement='right'
								size='small'
							>
								<div className='w-fit'>{content(isActive)}</div>
							</Tooltip>
						);
					}

					return content(isActive);
				}}
			</NavLink>
		</li>
	);
};

export default SidebarLinkItem;
